export const GROUP_GET_LIST_REQUEST = "GROUP_GET_LIST_REQUEST";
export const GROUP_GET_LIST_SUCCESS = "GROUP_GET_LIST_SUCCESS";
export const GROUP_GET_LIST_FAIL = "GROUP_GET_LIST_FAIL";

export const GROUP_GET_BY_ID_REQUEST = "GROUP_GET_BY_ID_REQUEST";
export const GROUP_GET_BY_ID_SUCCESS = "GROUP_GET_BY_ID_SUCCESS";
export const GROUP_GET_BY_ID_FAIL = "GROUP_GET_BY_ID_FAIL";

export const GROUP_CREATE_REQUEST = "GROUP_CREATE_REQUEST";
export const GROUP_CREATE_SUCCESS = "GROUP_CREATE_SUCCESS";
export const GROUP_CREATE_FAIL = "GROUP_CREATE_FAIL";

export const GROUP_SEND_MESSAGE_REQUEST = "GROUP_SEND_MESSAGE_REQUEST";
export const GROUP_SEND_MESSAGE_SUCCESS = "GROUP_SEND_MESSAGE_SUCCESS";
export const GROUP_SEND_MESSAGE_FAIL = "GROUP_SEND_MESSAGE_FAIL";
export const GROUP_VOICE_UPLOAD_COMPLETE = "GROUP_VOICE_UPLOAD_COMPLETE";

export const GROUP_NEW_MESSAGE = "GROUP_NEW_MESSAGE";
export const GROUP_SELECT = "GROUP_SELECT";
export const GROUP_LEAVE_ROOM = "GROUP_LEAVE_ROOM";
export const GROUP_RESET = "GROUP_RESET";

export const GROUP_ADD_MEMBER_SUCCESS = "GROUP_ADD_MEMBER_SUCCESS";
export const GROUP_REMOVE_MEMBER_SUCCESS = "GROUP_REMOVE_MEMBER_SUCCESS";
export const GROUP_SET_ADMIN_SUCCESS = "GROUP_SET_ADMIN_SUCCESS";
export const GROUP_ADD_TOPIC_SUCCESS = "GROUP_ADD_TOPIC_SUCCESS";
export const GROUP_UPDATE_TOPIC_SUCCESS = "GROUP_UPDATE_TOPIC_SUCCESS";
export const GROUP_DELETE_TOPIC_SUCCESS = "GROUP_DELETE_TOPIC_SUCCESS";
export const GROUP_DELETE_MESSAGE_SUCCESS = "GROUP_DELETE_MESSAGE_SUCCESS";
export const GROUP_BULK_DELETE_MESSAGES_SUCCESS = "GROUP_BULK_DELETE_MESSAGES_SUCCESS";
export const GROUP_LEAVE_SUCCESS = "GROUP_LEAVE_SUCCESS";
export const GROUP_PIN_MESSAGE_SUCCESS = "GROUP_PIN_MESSAGE_SUCCESS";
export const GROUP_UNPIN_MESSAGE_SUCCESS = "GROUP_UNPIN_MESSAGE_SUCCESS";
export const GROUP_EDIT_MESSAGE_SUCCESS = "GROUP_EDIT_MESSAGE_SUCCESS";

export const GROUP_SET_SELECTED_TOPIC = "GROUP_SET_SELECTED_TOPIC";

export const GROUP_CALL_ACTIVE = "GROUP_CALL_ACTIVE";
export const GROUP_CALL_ENDED = "GROUP_CALL_ENDED";

export const GROUP_MARK_SEEN = "GROUP_MARK_SEEN";
export const GROUP_REMOTE_SEEN = "GROUP_REMOTE_SEEN";
export const GROUP_MESSAGE_REACTION = "GROUP_MESSAGE_REACTION";

export const GROUP_SET_UNREAD_COUNTS = "GROUP_SET_UNREAD_COUNTS";

export const GROUP_BULK_MARK = "GROUP_BULK_MARK";
export const GROUP_BULK_MUTE = "GROUP_BULK_MUTE";
export const GROUP_BULK_REMOVE = "GROUP_BULK_REMOVE";

export const GROUP_TOGGLE_PUBLIC_SUCCESS = "GROUP_TOGGLE_PUBLIC_SUCCESS";
export const GROUP_GENERATE_LINK_SUCCESS = "GROUP_GENERATE_LINK_SUCCESS";
export const GROUP_PREVIEW_BY_LINK_REQUEST = "GROUP_PREVIEW_BY_LINK_REQUEST";
export const GROUP_PREVIEW_BY_LINK_SUCCESS = "GROUP_PREVIEW_BY_LINK_SUCCESS";
export const GROUP_PREVIEW_BY_LINK_FAIL = "GROUP_PREVIEW_BY_LINK_FAIL";
export const GROUP_JOIN_BY_LINK_SUCCESS = "GROUP_JOIN_BY_LINK_SUCCESS";
export const GROUP_JOIN_REQUESTS_SUCCESS = "GROUP_JOIN_REQUESTS_SUCCESS";
export const GROUP_PROCESS_JOIN_REQUEST_SUCCESS = "GROUP_PROCESS_JOIN_REQUEST_SUCCESS";
export const GROUP_UPDATE_INFO_SUCCESS = "GROUP_UPDATE_INFO_SUCCESS";

// Older messages (infinite scroll upward)
export const GROUP_LOAD_OLDER_MESSAGES_REQUEST = "GROUP_LOAD_OLDER_MESSAGES_REQUEST";
export const GROUP_LOAD_OLDER_MESSAGES_SUCCESS = "GROUP_LOAD_OLDER_MESSAGES_SUCCESS";
export const GROUP_LOAD_OLDER_MESSAGES_FAIL = "GROUP_LOAD_OLDER_MESSAGES_FAIL";
